/**
 * shared-layout.ts - Shared layout and utility variables for FMwvTool themes
 * 
 * These variables are theme-independent and should be identical across
 * light, dark, and any other theme variants. Only color variables should
 * differ between themes.
 * 
 * TIER 4: UTILITY VARIABLES (36)
 * - Typography (Font families, sizes, weights, line heights)
 * - Spacing scale
 * - Border radius
 * - Shadows
 * - Transitions
 */

export const sharedLayout = {
  // ========================================================================
  // TYPOGRAPHY
  // ========================================================================
  
  // Font Families (2)
  '--font-family': '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  '--font-family-mono': '"SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
  
  // Font Sizes (7)
  '--font-size-xs': '11px',
  '--font-size-sm': '12px',
  '--font-size-base': '14px',
  '--font-size-md': '16px',
  '--font-size-lg': '18px',
  '--font-size-xl': '20px',
  '--font-size-2xl': '24px',
  
  // Font Weights (4)
  '--font-weight-normal': '400',
  '--font-weight-medium': '500',
  '--font-weight-semibold': '600',
  '--font-weight-bold': '700',
  
  // Line Heights (3)
  '--line-height-tight': '1.25',
  '--line-height-normal': '1.5',
  '--line-height-relaxed': '1.75',
  
  // ========================================================================
  // SPACING SCALE
  // ========================================================================
  
  '--spacing-xs': '4px',
  '--spacing-sm': '8px',
  '--spacing-md': '12px',
  '--spacing-lg': '16px',
  '--spacing-xl': '24px',
  '--spacing-2xl': '32px',
  '--spacing-3xl': '48px',
  
  // ========================================================================
  // BORDER RADIUS
  // ========================================================================
  
  '--border-radius-sm': '3px',
  '--border-radius-md': '6px',
  '--border-radius-lg': '8px',
  '--border-radius-xl': '12px',
  '--border-radius-full': '9999px',
  
  // ========================================================================
  // TRANSITIONS
  // ========================================================================
  
  '--transition-fast': '100ms cubic-bezier(0.4, 0, 0.2, 1)',
  '--transition-normal': '200ms cubic-bezier(0.4, 0, 0.2, 1)',
  '--transition-slow': '300ms cubic-bezier(0.4, 0, 0.2, 1)',
};

export default sharedLayout;
